<template>
  <LoginRegisterPage />
</template>

<script lang="ts" setup>
import LoginRegisterPage from "@/features/auth/views/LoginRegisterPage.vue";

useHead({
  title: "Masuk",
});
</script>
